'use strict'

export default [
  {
    name:"Overview",
    fields: [
      { name:"period", type:"period" },
      { name:"summary", height: 5, includeStatus: true, optional: true },
      { name:"performedAchivements", height: 5, optional: true },
      { name:"plannedAchivements", height: 5, optional: true, excludedFor:["endStage","endProject"] },
      { name:"deliveryStatus", type:"table", optional:true, includedFor:[],
        columns: [
          { name:"product", dragable:true, editable:true},
          { name:"responsible", editable:true},
          { name:"dueDate", editable:true},
          { name:"status", editable:true}
        ],
        includeEmptyLine:true
      },
      { name:"benefits", height: 5, includeStatus: true, optional: true },
      { name:"time", height: 5, includeStatus: true, optional: true },
      { name:"cost", height: 5, includeStatus: true, optional: true },
      { name:"quality", height: 5, includeStatus: true, optional: true },
      { name:"scope", height: 5, includeStatus: true, optional: true },
      { name:"risk", height: 5, includeStatus: true, optional: true },

      { name:"teamPerformance", height: 5, optional: true, includedFor: ["endProject","endStage"]},
      { name:"lessonsDescription", height: 5, optional: true, includedFor: ["endProject","endStage"]},
    ]
  },{
    name:"Preview"
  }
];



// WEBPACK FOOTER //
// ./views/progress/formDefinition.js